/**
* 左边菜单
*/
<template>
  <el-menu default-active="1" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" text-color="#101010" active-text-color="#409eff">
    <!-- <div class="logobox">
      <img class="logoimg" src="../assets/img/copy.png" alt="">
	  <div class="logotitle">营销导购后台</div>
    </div> -->
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuid">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu,menunode } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [],
	  list:''
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
		  {
          menuid: '1',
          icon: 'li-icon-xiangmuguanli',
          menuname: '首页',
          hasThird:'N',
          url: null,
          menus: [
            {
              menuid: '11',
              icon: 'icon-cat-skuQuery',
              menuname: '首页',
              hasThird: 'N',
              url: 'index/index',
              menus: null
            }
          ]
        },
		{
		  menuid: '4',
		  icon: 'li-icon-xitongguanli',
		  menuname: '系统管理',
		  hasThird: null,
		  url: null,
		  menus: [
		    {
		      menuid: '41',
		      icon: 'icon-cus-manage',
		      menuname: '全部账号',
		      hasThird: 'N',
		      url: 'system/user',
		      menus: null
		    },
			{
			  menuid: '47',
			  icon: 'icon-cus-manage',
			  menuname: '后台管理账号',
			  hasThird: 'N',
			  url: 'system/administrators',
			  menus: null
			},
		    {
		      menuid: '42',
		      icon: 'icon-cms-manage',
		      menuname: '菜单管理',
		      hasThird: 'N',
		      url: 'system/Module',
		      menus: null
		    },
		    {
		      menuid: '43',
		      icon: 'icon-news-manage',
		      menuname: '角色管理',
		      hasThird: 'N',
		      url: 'system/Role',
		      menus: null
		    }
		    // {
		    //   menuid: '45',
		    //   icon: 'icon-promotion-manage',
		    //   menuname: '系统环境变量',
		    //   hasThird: 'N',
		    //   url: 'system/Variable',
		    //   menus: null
		    // },
		    // {
		    //   menuid: '46',
		    //   icon: 'icon-cms-manage',
		    //   menuname: '权限管理',
		    //   hasThird: 'N',
		    //   url: 'system/Permission',
		    //   menus: null
		    // }
		  ]
    },
	{
	    menuid: '10',
	    icon: 'li-icon-xiangmuguanli',
	    menuname: '用户管理',
	    hasThird:'N',
	    url: null,
	    menus: [
	      {
			menuid: '101',
			icon: 'icon-promotion-manage',
			menuname: '用户管理',
			hasThird: 'N',
			url: 'system/customer',
			menus: null
	      },
	      {
			menuid: '102',
			icon: 'icon-promotion-manage',
			menuname: '工程用户管理',
			hasThird: 'N',
			url: 'system/engineering',
			menus: null
	      },
	    ]
	  },
	{
	    menuid: '7',
	    icon: 'icon-news-manage',
	    menuname: '经销商资料',
	    hasThird:'N',
	    url: null,
	    menus: [
	      {
	        menuid: '71',
	        icon: 'icon-news-manage',
	        menuname: '驻村代表',
	        hasThird: 'N',
	        url: 'residency',
	        menus: null
	      },
		  {
		    menuid: '72',
		    icon: 'icon-news-manage',
		    menuname: '驻镇代表',
		    hasThird: 'N',
		    url: 'residentTown',
		    menus: null
		  },
		  {
		    menuid: '73',
		    icon: 'icon-news-manage',
		    menuname: '业务代表',
		    hasThird: 'N',
		    url: 'business',
		    menus: null
		  },
		    {
		      menuid: '74',
		      icon: 'icon-cs-manage',
		      menuname: '经销商管理',
		      hasThird: 'N',
		      url: 'system/distributor',
		      menus: null
        }
	    ]
	  },
	{
	    menuid: '6',
	    icon: 'icon-cat-skuQuery',
	    menuname: '导购工具',
	    hasThird:'N',
	    url: null,
	    menus: [
		   {
		     menuid: '64',
		     icon: 'li-icon-zhifuguanli',
		     menuname: '方案设计',
		     hasThird: 'N',
		     url: 'scheme',
		     menus: null
		   },
		  {
		    menuid: '63',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '签约管理',
		    hasThird: 'N',
		    url: 'sign',
		    menus: null
		  },
	      {
	        menuid: '61',
	        icon: 'li-icon-zhifuguanli',
	        menuname: '名片管理',
	        hasThird: 'N',
	        url: 'card',
	        menus: null
	      }
		  
	    ]
	  },
	  {
	      menuid: '8',
	      icon: 'icon-cat-skuQuery',
	      menuname: '考核数据',
	      hasThird:'N',
	      url: null,
	      menus: [
	        {
	          menuid: '81',
	          icon: 'li-icon-zhifuguanli',
	          menuname: '驻村代表',
	          hasThird: 'N',
	          url: 'residentData',
	          menus: null
	        },
			{
			  menuid: '82',
			  icon: 'li-icon-zhifuguanli',
			  menuname: '驻镇代表',
			  hasThird: 'N',
			  url: 'representTownData',
			  menus: null
			},
			{
			  menuid: '83',
			  icon: 'li-icon-zhifuguanli',
			  menuname: '分销商',
			  hasThird: 'N',
			  url: 'businessData',
			  menus: null
			},
			{
			  menuid: '84',
			  icon: 'li-icon-zhifuguanli',
			  menuname: '经销商',
			  hasThird: 'N',
			  url: 'dealerData',
			  menus: null
			},
			{
			  menuid: '85',
			  icon: 'li-icon-zhifuguanli',
			  menuname: '区域经理',
			  hasThird: 'N',
			  url: 'regionalManager',
			  menus: null
			},
			{
			  menuid: '89',
			  icon: 'li-icon-zhifuguanli',
			  menuname: '大区总监',
			  hasThird: 'N',
			  url: 'regionalDirector',
			  menus: null
			},
			{
			  menuid: '86',
			  icon: 'li-icon-gongsiguanli',
			  menuname: '目标值设置',
			  hasThird: 'N',
			  url: 'targetImport',
			  menus: null
			},
			
			{
			  menuid: '87',
			  icon: 'li-icon-gongsiguanli',
			  menuname: '考核明细导入',
			  hasThird: 'N',
			  url: 'assessmentDetails',
			  menus: null
			},
		   {
		    menuid: '88',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '订购会',
		    hasThird: 'N',
		    url: 'meeting',
		    menus: null
		   },
		   {
		    menuid: '812',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '家用新商拜访',
		    hasThird: 'N',
		    url: 'homeBusinessVisit',
		    menus: null
		   },
		   {
		    menuid: '80',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '商用新商拜访',
		    hasThird: 'N',
		    url: 'commercialBusinessVisit',
		    menus: null
		   },
		   {
		    menuid: '811',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '工程项目信息',
		    hasThird: 'N',
		    url: 'engineeringProject',
		    menus: null
		   }
	  	  
	      ]
	    },
	{
	    menuid: '3',
	    icon: 'li-icon-zhifuguanli',
	    menuname: '价目',
	    hasThird:'N',
	    url: null,
	    menus: [
	      {
	        menuid: '31',
	        icon: 'icon-cat-skuQuery',
	        menuname: '全国统一零售价',
	        hasThird: 'N',
	        url: 'retailprice',
	        menus: null
	      },
		  {
		    menuid: '32',
		    icon: 'icon-cat-skuQuery',
		    menuname: '采暖套餐指导价',
		    hasThird: 'N',
		    url: 'guideprice',
		    menus: null
		  }
	    ]
	  },
	  {
	      menuid: '5',
	      icon: 'li-icon-gongsiguanli',
	      menuname: '推荐用户资料',
	      hasThird:'N',
	      url: null,
	      menus: [
	        {
	          menuid: '31',
	          icon: 'icon-cms-refri',
	          menuname: '广告管理',
	          hasThird: 'N',
	          url: 'advertisement',
	          menus: null,
	        },
			{
			  menuid: '33',
			  icon: 'li-icon-gongsiguanli',
			  menuname: '产品推荐',
			  hasThird: 'N',
			  url: 'prodrecommend',
			  menus: null,
			  
			},
			{
			  menuid: '34',
			  icon: 'li-icon-gongsiguanli',
			  menuname: '活动推荐',
			  hasThird: 'N',
			  url: 'actrecommend',
			  menus: null
			},
	  	  {
	  	    menuid: '32',
	  	    icon: 'icon-cat-skuQuery',
	  	    menuname: '推荐分类管理',
	  	    hasThird: 'N',
	  	    url: 'categories',
	  	    menus: null
	  	  }
	      ]
	    },
    {
		  menuid: '2',
		  icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
		  menuname: '导购知识',
		  hasThird: null,
		  url: null,
		  menus: [
		    
		    {
		      menuid: '22',
		      icon: 'icon-cms-manage',
		      menuname: '产品介绍',
		      hasThird: 'N',
		      url: 'product',
		      menus: null
		    },
        {
		      menuid: '23',
		      icon: 'li-icon-gongsiguanli',
		      menuname: '产品卖点',
		      hasThird: 'N',
		      url: 'product1',
		      menus: null
		    },
        {
		      menuid: '24',
		      icon: 'icon-cms-refri',
		      menuname: '导购知识视频',
		      hasThird: 'N',
		      url: 'product2',
		      menus: null
		    },
			{
			      menuid: '25',
			      icon: 'icon-cms-manage',
			      menuname: '导购资料',
			      hasThird: 'N',
			      url: 'product3',
			      menus: null
			    },
				{
			      menuid: '26',
			      icon: 'li-icon-gongsiguanli',
			      menuname: '导购分类',
			      hasThird: 'N',
			      url: 'product4',
			      menus: null
			    },
        
		    {
		      menuid: '29',
		      icon: 'icon-news-manage',
		      menuname: '竞品对比',
		      hasThird: 'N',
		      url: 'competitive',
		      menus: null
		    },
		    // {
		    //   menuid: '45',
		    //   icon: 'icon-promotion-manage',
		    //   menuname: '系统环境变量',
		    //   hasThird: 'N',
		    //   url: 'system/Variable',
		    //   menus: null
		    // },
		    // {
		    //   menuid: '46',
		    //   icon: 'icon-cms-manage',
		    //   menuname: '权限管理',
		    //   hasThird: 'N',
		    //   url: 'system/Permission',
		    //   menus: null
		    // }
		  ]
		},
		{
		    menuid: '9',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '案例管理',
		    hasThird:'N',
		    url: null,
		    menus: [
				{
				      menuid: '91',
				      icon: 'icon-provider-manage',
				      menuname: '安装案例',
				      hasThird: 'N',
				      url: 'customerCase',
				      menus: null
				},
				{
				      menuid: '92',
				      icon: 'icon-cus-manage',
				      menuname: '用户回访',
				      hasThird: 'N',
				      url: 'customerCaseCallback',
				      menus: null
				},
		   //    {
		   //      menuid: '91',
		   //      icon: 'icon-cat-skuQuery',
		   //      menuname: '安装案例',
		   //      hasThird: 'N',
		   //      url: 'installation',
		   //      menus: null
		   //    },
			  // {
			  //   menuid: '92',
			  //   icon: 'icon-cat-skuQuery',
			  //   menuname: '用户回访',
			  //   hasThird: 'N',
			  //   url: 'returnvisit',
			  //   menus: null
			  // },
			  // {
			  //   menuid: '93',
			  //   icon: 'icon-cat-skuQuery',
			  //   menuname: '案例回访审核',
			  //   hasThird: 'N',
			  //   url: 'callbackexamine',
			  //   menus: null
			  // }
			  
		    ]
		  },
		// {
  //         menuid: '2',
  //         icon: 'li-icon-xiangmuguanli',
  //         menuname: '基础管理',
  //         hasThird: null,
  //         url: null,
  //         menus: [
  //           {
  //             menuid: '22',
  //             icon: 'icon-cat-skuQuery',
  //             menuname: '商品管理',
  //             hasThird: 'N',
  //             url: 'goods/Goods',
  //             menus: null
  //           }
  //         ]
  //       },
  //       {
  //         menuid: '3',
  //         icon: 'li-icon-dingdanguanli',
  //         menuname: '订单管理',
  //         hasThird: null,
  //         url: null,
  //         menus: [
  //           {
  //             menuid: '31',
  //             icon: 'icon-order-manage',
  //             menuname: '交易订单',
  //             hasThird: 'N',
  //             url: 'pay/Order',
  //             menus: null
  //           }
  //         ]
  //       },

        // {
        //   menuid: '5',
        //   icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        //   menuname: '支付管理',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: '51',
        //       icon: 'icon-provider-manage',
        //       menuname: '支付配置信息',
        //       hasThird: 'N',
        //       url: 'machine/MachineConfig',
        //       menus: null
        //     },
        //     {
        //       menuid: '52',
        //       icon: 'icon-provider-manage',
        //       menuname: '支付配置',
        //       hasThird: 'N',
        //       url: 'pay/Config',
        //       menus: null
        //     }
        //   ]
        // },
        // {
        //   menuid: '53',
        //   icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        //   menuname: '图表',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: '54',
        //       icon: 'icon-provider-manage',
        //       menuname: '数据可视化',
        //       hasThird: 'N',
        //       url: 'charts/statistics',
        //       menus: null
        //     }
        //   ]
        // }
      ],
      msg: 'success'
    }
	
	let res1 = {
	    success: true,
	    data: [
		{
		    menuid: '6',
		    icon: 'icon-cat-skuQuery',
		    menuname: '导购工具',
		    hasThird:'N',
		    url: null,
		    menus: [
		      {
		        menuid: '61',
		        icon: 'li-icon-zhifuguanli',
		        menuname: '名片管理',
		        hasThird: 'N',
		        url: 'card',
		        menus: null
		      },
			  // {
			  //   menuid: '62',
			  //   icon: 'li-icon-zhifuguanli',
			  //   menuname: '订购会预报',
			  //   hasThird: 'N',
			  //   url: 'meeting',
			  //   menus: null
			  // }
		    ]
		  },
		  
		{
		    menuid: '3',
		    icon: 'li-icon-zhifuguanli',
		    menuname: '价目',
		    hasThird:'N',
		    url: null,
		    menus: [
		      {
		        menuid: '31',
		        icon: 'icon-cat-skuQuery',
		        menuname: '全国统一零售价',
		        hasThird: 'N',
		        url: 'retailprice',
		        menus: null
		      },
			  {
			    menuid: '32',
			    icon: 'icon-cat-skuQuery',
			    menuname: '采暖套餐指导价',
			    hasThird: 'N',
			    url: 'guideprice',
			    menus: null
			  }
		    ]
		  },
		  {
		      menuid: '5',
		      icon: 'li-icon-gongsiguanli',
		      menuname: '推荐用户资料',
		      hasThird:'N',
		      url: null,
		      menus: [
		        {
		          menuid: '31',
		          icon: 'icon-cms-refri',
		          menuname: '广告管理',
		          hasThird: 'N',
		          url: 'advertisement',
		          menus: null
		        },
				{
				  menuid: '33',
				  icon: 'li-icon-gongsiguanli',
				  menuname: '产品推荐',
				  hasThird: 'N',
				  url: 'prodrecommend',
				  menus: null
				},
				{
				  menuid: '34',
				  icon: 'li-icon-gongsiguanli',
				  menuname: '活动推荐',
				  hasThird: 'N',
				  url: 'actrecommend',
				  menus: null
				},
		  	  {
		  	    menuid: '32',
		  	    icon: 'icon-cat-skuQuery',
		  	    menuname: '推荐分类管理',
		  	    hasThird: 'N',
		  	    url: 'categories',
		  	    menus: null
		  	  }
		      ]
		    },
			{
				  menuid: '2',
				  icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
				  menuname: '导购知识',
				  hasThird: null,
				  url: null,
				  menus: [
				   
					{
				      menuid: '24',
				      icon: 'icon-cms-refri',
				      menuname: '导购知识视频',
				      hasThird: 'N',
				      url: 'product2',
				      menus: null,
					  
				    },
					{
					      menuid: '25',
					      icon: 'icon-cms-manage',
					      menuname: '导购文件',
					      hasThird: 'N',
					      url: 'product3',
					      menus: null
					    },
						{
					      menuid: '26',
					      icon: 'li-icon-gongsiguanli',
					      menuname: '导购分类',
					      hasThird: 'N',
					      url: 'product4',
					      menus: null
					    }
				    
				  ]
				}
			
	    ],
	    msg: 'success'
	  }
	
	let user = getCookie('user')
	if(user=='admin'){
		 this.allmenu = res.data
	}else{
		 this.allmenu = res1.data
	}
	
	
	this.allmenu = JSON.parse(localStorage.getItem('WEB'))
	 // this.allmenu=[
		//  {
		//    menuid: "home",
		//    menuname: "首页",
		//    icon: 'li-icon-gongsiguanli',
		//    hasThird: "N",
		//    menus: [
		//      {
		//        menuid: "斤",
		//        menuname: "ui",
		//        hasThird: "N",
		//        menus: [],
		//        id: "斤",
		//  	  url: 'product4',
		//      },
		     
		//    ],
		//    "id": "home"
		//  }
	 // ]
	
	
	
	
	
	
	
	

    // let menuAppType = 'WEB'
    // menunode(menuAppType)
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
			 // console.log(666666666,res.data)
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
	
	
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
	
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE和Edge */
  height: 90%;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #fff !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 60px;
  color: #9d9d9d;
  font-size: 20px;
  border-bottom: 1px solid #e6e6e6;
}
.logoimg {
  height: 40px;
  margin-left: 20px;
  margin-top: 10px;
}
.el-menu-item-group .is-active{
	background-color: #e6f7ff;
}
.logotitle{
	font-size: 20px;
	height: 60px;
	line-height: 60px;
	color: #101010;
	float: right;
	font-weight: bold;
	margin-right: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue